import MonthlyScopeGapForecast from '@/models/MonthlyScopeGapForecast';
import MonthlyScopeGapForecastService from '@/services/MonthlyScopeGapForecastService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useMonthlyScopeGapForecastsStore = defineStore('monthly_scope_gap_forecasts', {
  state: () => ({}),

  getters: {
    models: () => useRepo(MonthlyScopeGapForecast),
  },

  actions: {
    async update(id: Id, request: ApiRequests['api.v1.monthly-scope-gap-forecasts.update']) {
      const [data, error] = await MonthlyScopeGapForecastService.update(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async destroy(id: Id) {
      const [data, error] = await MonthlyScopeGapForecastService.destroy(id);

      if(error) {
        throw error;
      }

      this.models.destroy(data.id);

      return data;
    },

    async sort(id: Id, request: ApiRequests['api.v1.monthly-scope-gap-forecasts.sort']) {
      const [data, error] = await MonthlyScopeGapForecastService.sort(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },
  },
});
